import React, { useState } from 'react'
import FilterPage, {generateInitialValue} from '../fragments/filter-page'
import {
	action_add_newarrivals_list,
	action_fetch_newarrivals_list,
	action_fetch_newarrivals_sorters,
	action_fetch_newarrivals_filter,
	__Default_NewArrivals_Limit_For_DeskTop__
} from '../../../../../store/actions/pages/new-arrivals'

import {
	action_fetch_list_top_banner
} from '../../../../../store/actions/global'


import { filterItemsToString, getFilterItemsFromQuery, getTopBanner, getUrl } from '../../../../pages/listing/utils'
import { useDispatch, useSelector } from 'react-redux'
import List from '../components/list'
import { useHistory } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Empty from '../fragments/empty-page'
import BlockImage from '../../../components/image/block-image'
import { useSensors } from '../../../../hooks/sensor'
import { generateFilter } from '../../../../utils/sensor'



const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}

	if(search?.recommend_data_source){
		newParams['recommendDataSource'] = search.recommend_data_source
	}

	return newParams
}


const NewArrivals = props => {
	useStyles(classes)
	const dispatch = useDispatch()
	const history = useHistory()
	const global = useSelector(state => state.global)
	const {listTopBanner} = global
	const pageNewArrivals = useSelector((state) => state.pageNewArrivals)
	const banner = getTopBanner(listTopBanner, 'newarrivals')
	const sorters = pageNewArrivals?.sorters
	const query = useQuery()
	const [rangeId, setRangeId] = useState(query?.rangeId)
	const [originQuery, setOriginQuery] = useState(query)
	const baseUrl = '/i/new-arrivals'

	const [data, setData] = useState({
		sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : query.sort,
		startPrice: Number(query?.lowerPrice) || undefined,
		endPrice: Number(query?.higherPrice) || undefined,
		filterItems: generateInitialValue(query, pageNewArrivals?.filterVo?.filterItems)
	})

	const sort = sorters?.findIndex(s => s.value === data?.sorter) || 0

	const filterHandle = (filterItems, sort, price) => {
		const filter = {
			sorter: (sorters instanceof Array) ? sorters?.[sort || 0]?.value : sort,
			startPrice: price?.minPrice || undefined,
			endPrice: price?.maxPrice || undefined,
			filterItems
		}
		setData(filter)
		dispatch(action_fetch_newarrivals_list(filter, { limit: __Default_NewArrivals_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source, rangeId }, {}))
        const url = getUrl(baseUrl, filterItemsToString(filterItems, sort, price))
		history.replace(url)
	}

	const onScroll = () => {
		dispatch(action_add_newarrivals_list(data, { ...query, parentSkus: query?.sort_by, skip: pageNewArrivals?.skip, limit: __Default_NewArrivals_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source, rangeId }, {}))
	}

	const [sensors, setSensors] = useState(useSensors())
	const filterStr = generateFilter(pageNewArrivals?.filterData, pageNewArrivals?.sorters)

	return <FilterPage
		links={[
			{
				href: '#',
				title: <span>
					<span>
                        <FormattedMessage id={'new_arrivals'} defaultMessage="New Arrivals"/>
                    </span>
					{
						pageNewArrivals?.total > 0 && <span className={classes.Total}>
							(<FormattedMessage id="count_items" values={{ total: pageNewArrivals?.total }} defaultMessage="{total} Items" />)
						</span>
					}
				</span>,
				keywords: [],
			}
		]}

		extra={() => {
			return <>
				{
					banner && banner.src &&  <div style={{marginTop: 20}}>
						<BlockImage sensors={{
							position: 1,
							content: banner.refId,
							type: '1',
							title: 'list'
						}} href={banner.href} title={banner.title} src={banner.src} width={banner.width} height={banner.height}/>
					</div>
				}
			</>
		}}


		baseUrl={baseUrl}
		title={<FormattedMessage id={'newarrivals'} defaultMessage="NewArrivals"/>}
		filterVO={pageNewArrivals?.filterVo}
		sorters={pageNewArrivals?.sorters}

		value={data?.filterItems}
        sort={sort}
        minPrice={data?.startPrice}
        maxPrice={data?.endPrice}

		onFilter={filterHandle}>
			{
				pageNewArrivals?.finished && (!pageNewArrivals?.list || pageNewArrivals?.list?.length < 1) ? <Empty /> : <List filter={filterStr} sensors={sensors} products={pageNewArrivals?.list} request={onScroll} loading={pageNewArrivals?.loading} finished={pageNewArrivals?.finished} />
			}
	</FilterPage>
}


NewArrivals.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_newarrivals_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
	const filter = {
		sorter: sorter,
		startPrice: Number(search?.lowerPrice) || undefined,
		endPrice: Number(search?.higherPrice) || undefined,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const parsedParams = parseParams(search) || {}

	parsedParams.limit = __Default_NewArrivals_Limit_For_DeskTop__

	const values = await Promise.all([
		store.dispatch(action_fetch_newarrivals_list(filter, {...parsedParams, rangeId: search?.rangeId}, headers)),
		store.dispatch(action_fetch_newarrivals_filter({}, headers)),
        store.dispatch(action_fetch_list_top_banner(headers)),
	])

	return [...values, sorters]
}

export default NewArrivals